import React from 'react';

import './Banner.css';
import bgImage from '../../images/berekenorv.jpg';

export const Banner = () => (
  <header className="banner orv">
    <div className="contain contain-wide">
      <div className="banner-inner">
        <div className="banner-text-wr">
          <div className="banner-text">
            <h1>Premie berekenen Maandlastbeschermer</h1>
            <p>De TAF Werknemers AOV is speciaal ontwikkeld voor eigenwoningbezitters in loondienst.
              Hiermee voorkomt u dat u in de financiële problemen raakt als u niet meer kunt werken door
              arbeidsongeschiktheid. Aanvullend kunt u zich verzekeren voor onvrijwillige werkloosheid.
              Vul onderstaande velden in en u ziet meteen de premie van de TAF Maandlastbeschermer.
              Wilt u de verzekering afsluiten? Ga naar uw financieel adviseur. Heeft u nog geen financieel adviseur?&nbsp;
              <a href="https://www.taf.nl/service-en-contact/vind-een-adviseur">Vind er een bij u in de
                buurt
              </a>.
            </p>
          </div>
        </div>
        <div className="bg-img">
          <img className="bg-img" src={bgImage} alt="TAF - Bereken hier uw premie"/>
        </div>
      </div>
    </div>
  </header>
);
